import _ from 'lodash';

export const replaceObjectProperty = (data: any[], propToReplace: string[]): any[] => {
  return data.map((item) => ({ ..._.omit(item, propToReplace) }));
};
